import { Component, EventBus } from '../core/smpl-components'
import { Events } from '../core/events'
import { ExpandableElement } from '../modules/expandable-element'

/** Text expandable
 *
 * Text after a <!--more--> tag starts collapsed; the toggle below it expands
 * the rest and swaps its label between data-label-more / data-label-less.
 */
// -------------------------------------------------------------------------- //
export default class extends Component {
	prepare() {}
	mount() {
		const elToggle = this.element.querySelector('.js-text-expandable-toggle')
		const elLabel = elToggle.querySelector('span')

		this.expandable = new ExpandableElement({
			element: this.element,
			toggleElement: elToggle,
			measureMode: 'content',
			cbOnChange: (state) => {
				elLabel.textContent = state === 'expanded' ? elToggle.dataset.labelLess : elToggle.dataset.labelMore
			},
			cbOnAfterChange: () => EventBus.emit(Events.PAGE_RESIZE),
		})
	}
	unmount() {
		if (this.expandable) {
			this.expandable.destroy()
			this.expandable = null
		}
	}
}
